import { property as n } from './property.js';

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */function t(t){return n({...t,state:!0})}

export { t as state };
//# sourceMappingURL=state.js.map
